import {baseApi} from './baseApi';

export const injectedCorrespondenceApi = baseApi.injectEndpoints({
    addTagTypes: ['Correspondence'],
    endpoints: (builder) => ({
        getCorrespondence: builder.query({
            query: (args) => {
                const {projectId, personId} = args;

                let url = `getCorrespondence?project_id=${projectId}&person_id=${personId}`;

                return {url: url};
            },
            providesTags: ['Correspondence']
        }),
        getProjectCorrespondenceTypes: builder.query({
            query: (args) => {
                const {projectId} = args;

                let url = `getProjectCorrespondenceTypes?project_id=${projectId}`;

                return {url: url};
            },
            providesTags: ['Correspondence']
        }),
        refetchErroredQueries: builder.mutation({
            queryFn: () => ({data: null}),
            invalidatesTags: ['UNKNOWN_ERROR'],
        }),
        createCorrespondence: builder.mutation({
            query: (data) => ({
                url: 'createCorrespondence',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Correspondence']
        }),
        updateCorrespondence: builder.mutation({
            query: (data) => ({
                url: 'updateCorrespondence',
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Correspondence']
        }),
        deleteCorrespondence: builder.mutation({
            query: (data) => ({
                url: 'deleteCorrespondence',
                method: 'DELETE',
                body: data,
            }),
            invalidatesTags: ['Correspondence']
        }),
    }),
});

export const {
    useGetCorrespondenceQuery,
    useGetProjectCorrespondenceTypesQuery,
    useCreateCorrespondenceMutation,
    useUpdateCorrespondenceMutation,
    useDeleteCorrespondenceMutation,
} = injectedCorrespondenceApi;
